import { Button } from '@/components/ui/button'
import { usePrintWindow } from '@/hooks/usePrintWindow'
// oxlint-disable-next-line no-restricted-imports -- grandfathered
import { printCashDrawerSlip } from '@/lib/services/cash-drawers/cash-drawers.api'
import { getErrorMessage } from '@/lib/utils'
import { useParams } from '@tanstack/react-router'
import { Printer } from 'lucide-react'
import { toast } from 'sonner'

// The slip is kept with the deposit; it prints the server-rendered close summary.
export function useCashDrawerSlipPrinter() {
  const { orgId } = useParams({ strict: false })
  const { openPrintWindow } = usePrintWindow({
    onError: (error) =>
      toast.error('Unable to print the slip', { description: getErrorMessage(error) }),
  })

  // Must run inside a click handler so the browser allows the print window.
  return (sessionId) =>
    openPrintWindow({
      loadHtml: () => printCashDrawerSlip({ organizationId: orgId, sessionId }),
      title: 'Drawer balancing slip',
      autoPrint: true,
    })
}

export function PrintCashDrawerSlipButton({ sessionId, variant = 'outline', size = 'sm' }) {
  const printSlip = useCashDrawerSlipPrinter()

  return (
    <Button type="button" variant={variant} size={size} onClick={() => printSlip(sessionId)}>
      <Printer className="size-4" />
      Print slip
    </Button>
  )
}
